import { render, staticRenderFns } from "./role-management.vue?vue&type=template&id=46e99bf8&scoped=true&"
import script from "./role-management.vue?vue&type=script&lang=js&"
export * from "./role-management.vue?vue&type=script&lang=js&"
import style0 from "./role-management.vue?vue&type=style&index=0&id=46e99bf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e99bf8",
  null
  
)

export default component.exports